import {
  Button as MuiButton,
  Card as MuiCard,
  CardContent as MuiCardContent,
  OutlinedInput as MuiOutlinedInput,
  Typography as MuiTypography,
} from '@mui/material';
import styled from 'styled-components';

const COLORS = {
  bg: 'linear-gradient(135deg, #dde4f0 0%, #eef1f7 50%, #f4f6fa 100%)',
  card: '#ffffff',
  border: '#e2e8f0',
  label: '#64748b',
  inputBg: '#f1f4f9',
  icon: '#94a3b8',
  text: '#1e2d5e',
  primary: '#4F73F7',
};

export const PageBackground = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${COLORS.bg};
  overflow: hidden;
`;

export const LoginCard = styled(MuiCard)`
  width: 460px !important;
  background-color: ${COLORS.card} !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1) !important;
  border-radius: 12px !important;
  border: 1px solid ${COLORS.border} !important;
`;

export const CardBody = styled(MuiCardContent)`
  padding: 32px !important;
`;

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 28px;
`;

export const LogoImage = styled.img`
  height: 56px;
  margin-bottom: 12px;
`;

export const PageTitle = styled(MuiTypography)`
  font-family: 'Poppins', sans-serif !important;
  font-weight: 600 !important;
  color: ${COLORS.text} !important;
  letter-spacing: 0.02em !important;
`;

export const PageSubtitle = styled(MuiTypography)`
  font-family: 'Poppins', sans-serif !important;
  color: ${COLORS.label} !important;
  margin-top: 4px !important;
`;

export const FieldWrapper = styled.div`
  margin-bottom: 20px;
`;

export const FieldLabel = styled(MuiTypography)`
  display: block !important;
  font-family: 'Poppins', sans-serif !important;
  font-weight: 600 !important;
  color: ${COLORS.label} !important;
  letter-spacing: 0.08em !important;
  text-transform: uppercase !important;
  margin-bottom: 6px !important;
`;

export const StyledInput = styled(MuiOutlinedInput)`
  background-color: ${COLORS.inputBg} !important;
  border-radius: 10px !important;

  & fieldset {
    border-color: ${COLORS.border};
    border-radius: 10px;
  }

  &:hover fieldset {
    border-color: ${COLORS.primary} !important;
  }

  &.Mui-focused fieldset {
    border-color: ${COLORS.primary} !important;
  }

  & input {
    color: ${COLORS.text};
    padding-top: 11px;
    padding-bottom: 11px;
    font-family: 'Poppins', sans-serif;
  }
`;

export const SubmitButton = styled(MuiButton)`
  padding-top: 11px !important;
  padding-bottom: 11px !important;
  background-color: ${COLORS.text} !important;
  font-family: 'Poppins', sans-serif !important;
  font-weight: 500 !important;
  font-size: 0.85rem !important;
  letter-spacing: 0.08em !important;
  border-radius: 10px !important;
  text-transform: uppercase !important;
  box-shadow: none !important;

  &:hover {
    background-color: #162249 !important;
    box-shadow: none !important;
  }
`;
